import Vue from "vue";

const scrollSmoothlyToSelector = (selector, timer = 500) => {
  setTimeout(() => {
    const element_scroll = document.querySelector(selector);
    if (!element_scroll) {
      return;
    }
    element_scroll.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }, timer);
};

class QNotice {
  public success(data: any) {
    return Vue.notify({
      group: "admin",
      type: "brighttheme-success",
      classes: ["pnotify"],
      ...data,
    });
  }
  public error(data: any) {
    scrollSmoothlyToSelector(".mb__error:has(li)");

    return Vue.notify({
      group: "admin",
      type: "brighttheme-error",
      ...data,
    });
  }
}

export default new QNotice();
